var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 65,
    viewBox: "0 0 60 65",
    fill: "none",
    id: "svg9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9178 0H0V21.9178H21.9178V0Z",
    fill: "#845EC2",
    id: "path1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.0962 30.6851H4.82227V42.959H17.0962V30.6851Z",
    fill: "white",
    stroke: "#BDCAD1",
    strokeWidth: 1.4651,
    strokeMiterlimit: 10,
    id: "path2",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0962 51.7261H4.82227V64H17.0962V51.7261Z",
    fill: "white",
    stroke: "#BDCAD1",
    strokeWidth: 1.4651,
    strokeMiterlimit: 10,
    id: "path3",
    style: {
      fill: "none"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9316 33.7534H60.0009",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40H50",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9316 7.89062H60.0009",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14H50",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9316 54.7944H60.0009",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29 61H50",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement);
export default __webpack_public_path__ + "static/media/element.102364fba88a767bd758885d6eb62bf6.svg";
export { ForwardRef as ReactComponent };